import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIssueDamaged = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M3.89 12.374a5.5 5.5 0 0 0 7.777 7.778l9.193-9.192a5.5 5.5 0 1 0-7.778-7.778l-9.193 9.192zm10.606-7.778-1.7 1.7 4.95 4.95 1.7-1.7a3.5 3.5 0 0 0-4.95-4.95zm-6.2 6.2 3.086-3.086 4.95 4.95-3.086 3.086-4.95-4.95zM6.882 12.21l-1.579 1.58a3.5 3.5 0 1 0 4.95 4.95l1.579-1.58-4.95-4.949z",
		clipRule: "evenodd"
	})
});
export default SvgIssueDamaged;
